import { QueryKey } from 'react-query';

export const queryKeys = {
  all: ['cart'],
  cart: (payload: { shopId: string; id: string }): QueryKey => [...queryKeys.all, payload],
};
